import Component from './RecordsViewerBranch.component';

export default Component;
